import gsap from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"

export class MarketsProgress {
  constructor() {
    this.isInitialized = false
    this.scrollTrigger = null
    this.timeline = null
    this.resizeHandler = null

    this.marketsSVGs = gsap.utils.toArray(".card_markets_svg")
    this.marketsContents = gsap.utils.toArray(".card_markets_content")
    this.marketsDot = document.querySelector(".card_markets_dot")
  }

  init() {
    if (this.isInitialized) return

    gsap.registerPlugin(ScrollTrigger)
    this.initAnimation()
    this.bindResize()
    this.isInitialized = true
  }

  initAnimation() {
    this.cleanup()

    const isMobile = window.innerWidth < 992

    this.timeline = gsap.timeline()
      .set(this.marketsSVGs, { color: "#DFDFDF" })
      .set(this.marketsContents, { opacity: 0.5 })
      // Animate the line
      .fromTo(".card_market_line",
        isMobile ? { height: "0%", width: "1px" } : { width: "0%", height: "1px" },
        {
          ...(isMobile ? { height: "100%", width: "1px" } : { width: "100%", height: "1px" }),
          transformOrigin: isMobile ? "top center" : "left center",
          duration: 1,
          ease: "power1.out",
        }
      )
      .to(this.marketsSVGs[0], {
        backgroundColor: "var(--swatch--brand-500)",
        duration: 0.2,
        ease: "power2.out"
      }, 0)
      .to(this.marketsContents[0], {
        opacity: 1,
        duration: 0.2,
        ease: "power2.out"
      }, "<")
      .to(this.marketsSVGs[1], {
        backgroundColor: "var(--swatch--brand-500)",
        duration: 0.2,
        ease: "power2.out"
      }, 0.25)
      .to(this.marketsContents[1], {
        opacity: 1,
        duration: 0.2,
        ease: "power2.out"
      }, "<")
      .to(this.marketsSVGs[2], {
        backgroundColor: "var(--swatch--brand-500)",
        duration: 0.2,
        ease: "power2.out"
      }, 0.6)
      .to(this.marketsContents[2], {
        opacity: 1,
        duration: 0.2,
        ease: "power2.out"
      }, "<")
      .to(this.marketsDot, {
        scale: 0,
        marginLeft: isMobile ? "0rem" : "-1rem",
        marginTop: isMobile ? "-.2rem" : "0rem",
        duration: 0.2,
        ease: "power2.out"
      }, ">")

    const trigger = ScrollTrigger.create({
      trigger: "#marketsSection",
      start: isMobile ? "top 50%" : "0% 60%",
      end: "bottom center",
      scrub: true,
      animation: this.timeline,
    })
  }

  bindResize() {
    this.resizeHandler = this.debounceResize(() => {
      ScrollTrigger.refresh()
      this.initAnimation()
    }, 250)
    window.addEventListener("resize", this.resizeHandler)
  }

  debounceResize(fn, ms) {
    let last = innerWidth
    let timer
    return function (...args) {
      clearTimeout(timer)
      timer = setTimeout(() => {
        if (innerWidth !== last) {
          last = innerWidth
          fn.apply(this, args)
        }
      }, ms)
    }
  }

  cleanup() {
    if (this.scrollTrigger) {
      this.scrollTrigger.kill()
      this.scrollTrigger = null
    }
    if (this.timeline) {
      this.timeline.kill()
      this.timeline = null
    }
  }

  destroy() {
    this.cleanup()
    if (this.resizeHandler) {
      window.removeEventListener("resize", this.resizeHandler)
      this.resizeHandler = null
    }

    this.isInitialized = false
  }
}